<template>
    <component :is="homeConponent"></component>
</template>

<script>
export default {
    components: {
        Home: () => import('./home/index.vue'),
    },
    asyncData ({ req }) {
        var homeConponent = 'Home';
       
        return {
            homeConponent,
        };
    },
    data () {
        
    },

    mounted () {
        
    },
};
</script>